import * as validateRule from './validateRule.js';

/**
 * フォーム共通Validate処理。
 *
 * 項目単体では実施できないValidateを行う。
 * ・開始日と終了日の整合性チェック
 *
 * @param {object} values 入力値情報
 * @return {object} エラー情報。キー:項目名、値:エラー内容
 */
export const validate = (values) => {
  const errors = {};

  // 開始日と終了日の整合性チェック
  Object.assign(errors, isCorrectDataFromTo(values));

  return errors;
};

/**
 * 開始日と終了日の整合性チェック。
 *
 * @param {object} values 入力値情報
 * @return {object} エラー情報。キー:項目名、値:エラー内容
 */
const isCorrectDataFromTo = (values) => {
  const errors = {};

  for (const itemName in values) {
    if (!Object.hasOwn(values, itemName)) {
      continue;
    }

    // 'From'で終わる項目名ではない場合はスキップ
    if (!itemName.endsWith('From')) {
      continue;
    }

    // Fromの項目名
    const itemNameFrom = itemName;

    // Toの項目名
    const baseName = itemName.substring(0, itemName.lastIndexOf('From'));
    const itemNameTo = baseName + 'To';

    // Toの項目名に紐づく入力値が存在しない場合はスキップ
    if (!Object.hasOwn(values, itemNameTo)) {
      continue;
    }

    // From、Toの入力値を取得
    const valueFrom = values[itemNameFrom];
    const valueTo = values[itemNameTo];

    // 共通メソッドで開始日と終了日の整合性をチェック
    errors[itemNameFrom] = validateRule.correctFromDate(valueTo)(valueFrom);
    errors[itemNameTo] = validateRule.correctDate(valueFrom)(valueTo);
  }

  return errors;
};
